import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Feeling",
    opening: localizedGenderNode(
      [
      "Today I do not try to convince myself otherwise.",
      "I only notice: I have a feeling life passed me by.",
      "I am here."
    ],
      [
      "Today I do not try to convince myself otherwise.",
      "I only notice: I have a feeling life passed me by.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is this feeling especially strong?",
      "What do I tell myself in those moments?",
      "What do I feel in my body?"
    ],
      [
      "When is this feeling especially strong?",
      "What do I tell myself in those moments?",
      "What do I feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The feeling is an experience, not me."
    ],
      [
      "The feeling is an experience, not me."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"I am here with the feeling\".",
      "one breath + \"I am here with the feeling\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The First Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the moment the feeling begins.",
      "I only notice.",
      "I stay with myself."
    ],
      [
      "Today I notice the moment the feeling begins.",
      "I only notice.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I sit with myself for a moment.",
      "One breath."
    ],
      [
      "I sit with myself for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens right before the feeling rises?",
      "Where does it meet me in the day?",
      "What am I trying to avoid?"
    ],
      [
      "What happens right before the feeling rises?",
      "Where does it meet me in the day?",
      "What am I trying to avoid?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "In the first moment I have a little space."
    ],
      [
      "In the first moment I have a little space."
    ]
    ),
    action: localizedGenderNode(
      "one breath when it starts.",
      "one breath when it starts."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Body Signals",
    opening: localizedGenderNode(
      [
      "Today I listen to my body before the thought.",
      "I stay with myself.",
      "I am here."
    ],
      [
      "Today I listen to my body before the thought.",
      "I stay with myself.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does my body feel the feeling?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ],
      [
      "Where does my body feel the feeling?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is trying to keep me safe."
    ],
      [
      "My body is trying to keep me safe."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest and one breath.",
      "a hand on my chest and one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Story vs. Fact",
    opening: localizedGenderNode(
      [
      "Today I separate fact from story.",
      "I do not fight the story.",
      "I stay with myself."
    ],
      [
      "Today I separate fact from story.",
      "I do not fight the story.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the simple fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ],
      [
      "What is the simple fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not me."
    ],
      [
      "A story is not me."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is a story rising\".",
      "an inner sentence - \"This is a story rising\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "What Went Quiet",
    opening: localizedGenderNode(
      [
      "Today I notice what went quiet in me.",
      "Not to blame.",
      "I stay with myself."
    ],
      [
      "Today I notice what went quiet in me.",
      "Not to blame.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my feet.",
      "One breath."
    ],
      [
      "I feel my feet.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is usually missing for me?",
      "When do I feel a little more alive?",
      "What do I miss?"
    ],
      [
      "What is usually missing for me?",
      "When do I feel a little more alive?",
      "What do I miss?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing what went quiet is already a connection."
    ],
      [
      "Noticing what went quiet is already a connection."
    ]
    ),
    action: localizedGenderNode(
      "write one thing I miss.",
      "write one thing I miss."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Inner Voice",
    opening: localizedGenderNode(
      [
      "Today I listen to my inner voice.",
      "Without forcing.",
      "I am here."
    ],
      [
      "Today I listen to my inner voice.",
      "Without forcing.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my shoulders a little.",
      "One breath."
    ],
      [
      "I soften my shoulders a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does my inner voice say about this feeling?",
      "What does that voice need from me?",
      "What sounds softer inside me?"
    ],
      [
      "What does my inner voice say about this feeling?",
      "What does that voice need from me?",
      "What sounds softer inside me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A gentle inner voice is a beginning."
    ],
      [
      "A gentle inner voice is a beginning."
    ]
    ),
    action: localizedGenderNode(
      "one soft inner sentence.",
      "one soft inner sentence."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A Small Need",
    opening: localizedGenderNode(
      [
      "Today I touch the need under this feeling.",
      "I do not solve.",
      "I stay with myself."
    ],
      [
      "Today I touch the need under this feeling.",
      "I do not solve.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I place a hand on my chest.",
      "One breath."
    ],
      [
      "I place a hand on my chest.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to feel a little more alive?",
      "What in me asks for warmth or closeness?",
      "How does it feel when I give myself a moment?"
    ],
      [
      "What do I need to feel a little more alive?",
      "What in me asks for warmth or closeness?",
      "How does it feel when I give myself a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Behind the feeling there is a request."
    ],
      [
      "Behind the feeling there is a request."
    ]
    ),
    action: localizedGenderNode(
      "write one request to myself.",
      "write one request to myself."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A Small Connection",
    opening: localizedGenderNode(
      [
      "Today I look for a small connection inside me.",
      "Not big, just possible.",
      "I am here."
    ],
      [
      "Today I look for a small connection inside me.",
      "Not big, just possible.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my back supported.",
      "One breath."
    ],
      [
      "I feel my back supported.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What gives me a sense of connection now?",
      "What word calms me?",
      "What can I give myself for a moment?"
    ],
      [
      "What gives me a sense of connection now?",
      "What word calms me?",
      "What can I give myself for a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small connection is still connection."
    ],
      [
      "A small connection is still connection."
    ]
    ),
    action: localizedGenderNode(
      "one quiet word in my heart.",
      "one quiet word in my heart."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Compassion for Myself",
    opening: localizedGenderNode(
      [
      "Today I speak to myself gently.",
      "Not like a judge.",
      "I am here."
    ],
      [
      "Today I speak to myself gently.",
      "Not like a judge.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I soften my jaw.",
      "One breath."
    ],
      [
      "I soften my jaw.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What can I forgive myself for?"
    ],
      [
      "How would I speak to a friend here?",
      "What soft sentence do I need to hear?",
      "What can I forgive myself for?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Gentleness does not cancel the feeling."
    ],
      [
      "Gentleness does not cancel the feeling."
    ]
    ),
    action: localizedGenderNode(
      "one soft sentence to myself.",
      "one soft sentence to myself."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "An Inner Request",
    opening: localizedGenderNode(
      [
      "Today I give myself one clear request.",
      "Not a demand, just a request.",
      "I am here."
    ],
      [
      "Today I give myself one clear request.",
      "Not a demand, just a request.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my belly soften a little.",
      "One breath."
    ],
      [
      "I feel my belly soften a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ],
      [
      "What is my most important request right now?",
      "How do I say it in one sentence?",
      "What am I willing to give myself in return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can help me move."
    ],
      [
      "One request can help me move."
    ]
    ),
    action: localizedGenderNode(
      "write the request in a short sentence.",
      "write the request in a short sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A Small Change",
    opening: localizedGenderNode(
      [
      "Today I choose a small change within the day.",
      "Not a revolution, just a small step.",
      "I stay with myself."
    ],
      [
      "Today I choose a small change within the day.",
      "Not a revolution, just a small step.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice one point of contact in my body.",
      "One breath."
    ],
      [
      "I notice one point of contact in my body.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small change am I willing to try this week?",
      "When in the day is it easiest to try it?",
      "What will gently remind me to choose it?"
    ],
      [
      "What small change am I willing to try this week?",
      "When in the day is it easiest to try it?",
      "What will gently remind me to choose it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small change is a real beginning."
    ],
      [
      "A small change is a real beginning."
    ]
    ),
    action: localizedGenderNode(
      "choose one moment to try it.",
      "choose one moment to try it."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Choosing Presence",
    opening: localizedGenderNode(
      [
      "Today I check the moment of choice.",
      "Between disappearing and presence.",
      "I am here."
    ],
      [
      "Today I check the moment of choice.",
      "Between disappearing and presence.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I hear my breath.",
      "One breath."
    ],
      [
      "I hear my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I choose when I feel life passed me by?",
      "What small choice of presence is possible for me?",
      "How do I feel after that choice?"
    ],
      [
      "What do I choose when I feel life passed me by?",
      "What small choice of presence is possible for me?",
      "How do I feel after that choice?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small choice changes the direction."
    ],
      [
      "A small choice changes the direction."
    ]
    ),
    action: localizedGenderNode(
      "say in my heart \"I choose to be here\" once.",
      "say in my heart \"I choose to be here\" once."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Direction",
    opening: localizedGenderNode(
      [
      "Today I notice where I want to move.",
      "Not far, just a small direction.",
      "I stay with myself."
    ],
      [
      "Today I notice where I want to move.",
      "Not far, just a small direction.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my sitting.",
      "One breath."
    ],
      [
      "I feel my sitting.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I want to feel more in life?",
      "What small value do I want to live today?",
      "What is a small sign that it is happening?"
    ],
      [
      "What do I want to feel more in life?",
      "What small value do I want to live today?",
      "What is a small sign that it is happening?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A gentle direction is enough to begin."
    ],
      [
      "A gentle direction is enough to begin."
    ]
    ),
    action: localizedGenderNode(
      "one short value sentence.",
      "one short value sentence."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ],
      [
      "Today I close the journey gently.",
      "Without forcing a perfect ending.",
      "I am here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this feeling?",
      "What is the early sign that I am entering it?",
      "Return sentence for the moment before - what do I say to myself?"
    ],
      [
      "What did I learn about this feeling?",
      "What is the early sign that I am entering it?",
      "Return sentence for the moment before - what do I say to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I do not have to erase the feeling to be present."
    ],
      [
      "I do not have to erase the feeling to be present."
    ]
    ),
    action: localizedGenderNode(
      "one breath before responding.",
      "one breath before responding."
    ),
  },
].map(buildNormalizedDay);

export const theFeelingOfLifePassedMeByBlueprintEn = buildNormalizedPilotBlueprint({
  id: "the_feeling_of_life_passed_me_by_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "the_feeling_of_life_passed_me_by",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "תחושה שהחיים עברו לידי",
    en: "The feeling that life passed me by",
    es: "La sensación de que la vida pasó de largo",
  },
  days,
});

export default theFeelingOfLifePassedMeByBlueprintEn;
